/**Colors used through application */
export class TemplateColors
{
	static readonly nauBlue = "#0077BD";
	static readonly nauOrange = "#F97C00";
	static readonly nauGrey = "#3e3e3e";
	static readonly disabledState = "#e89895";
}

/**Template build functions and constants */
export class Templates
{
	static readonly Ids = {
		// main page ids
		revenueStateFormSelection: "revenueStateFormSelection",
		stateDxDropDown: "stateDxDropDownDiv",
		yearDxDropDown: "yearDxDropDownDiv",
		filterDxDropDown: "filterDxDropDownDiv",
		 
		vectorMapContainer: "vectorMapContainerDiv",
		gridContainer: "gridContainerDiv",
		simpleList: "simpleListDiv",
		revenuePriceGraph: "revenuePriceGraph",
		 
		// detail popup ids
		popupYearDiv: "popupYearDiv",
		popupMonthDiv: "popupMonthDiv",
		popupTypeDiv: "popupTypeDiv",
		popupPracticeDiv: "popupPracticeDiv",
		popupSalesCloseDiv: "popupSalesCloseDiv",
		popupExchangeDiv: "popupExchangeDiv",
		popupFactorDataDiv: "popupFactorDataDiv",
		popupFactorDiv: "popupFactorDiv",
		 
		popupProjectedDiv: "popupProjectedDiv",
		popupVolatilityDiv: "popupVolatilityDiv",
		popupHarvestedDiv: "popupHarvestedDiv",
		popupProjectedStatusDiv: "popupProjectedStatusDiv",
		popupVolatilityStatusDiv: "popupVolatilityStatusDiv",
		popupHarvestedStatusDiv: "popupHarvestedStatusDiv",
		 
		// unsupported states ids
		unsupportedStatePopup: "unsupportedStatePopupDiv",
		unsupportedStateText: "unsupportedStateTextDiv",
		 
		// chart ids
		popupChartToggleDiv: "ChartToggle",
		popupMobileChartSwitch: "popupMobileChartSwitchDiv",
		popupChartRow: "ChartRow",
		popupRevenuePricesChart: "chart",
		
		// data grids
		popupBasePriceHeaderDiv: "basePriceHeader",
		popupGridBasePriceDiv: "gridBasePrice",
		popupHarvestPriceHeaderDiv: "harvestPriceHeader",
		popupGridHarvestPriceDiv: "gridHarvestPrice"
	}

	public static PageTemplate()
	{
		var pageTemplate = "";

		// Price Panel
		pageTemplate += "	<div class=\"nau-panel \">";
		pageTemplate += "		<div class=\"panel-heading\">Revenue Prices<\/div>";
		pageTemplate += "		<div class=\"panel-body form-body\">";

		// Input Row
		pageTemplate += "			<div class=\"row\">";
			
		// Input Column
		pageTemplate += "				<div class=\"col-xs-12 col-sm-4 dropdown-collection\"> <div id=\"" + Templates.Ids.revenueStateFormSelection + "\"><\/div><\/div>";

		// Map Column
		pageTemplate += "				<div class=\"col-xs-8 hidden-xs\">";
		pageTemplate += "					<div id=\"" + Templates.Ids.vectorMapContainer + "\" style=\"height: 300px; width: 100%; margin: 0 auto\"><\/div>";
		pageTemplate += "				<\/div>";
		pageTemplate += "			<\/div>";
			
		// Spacer Row
		pageTemplate += "			<div class=\"row\">";
		pageTemplate += "				<div class=\"col-xs-12\">&nbsp;<\/div>";
		pageTemplate += "			<\/div>";

		// Grid Row
		pageTemplate += "			<div class=\"row\">";
		pageTemplate += "				<div class=\"col-sm-12 hidden-xs\">";
		pageTemplate += "					<div id=\"" + Templates.Ids.gridContainer + "\" class=\"nau-data-grid\"><\/div>";
		pageTemplate += "				<\/div>";
		pageTemplate += "				<div class=\"col-xs-12 hidden-lg hidden-md hidden-sm\">";
		pageTemplate += "					<div class=\"nau-dx-list\" id=\"" + Templates.Ids.simpleList + "\">";
		pageTemplate += "				<\/div>";
		pageTemplate += "			<\/div>";
		pageTemplate += "		<\/div>"; // End Panel body
		pageTemplate += "	<\/div>"; // End Panel 

		pageTemplate += "	<div id=\"" + Templates.Ids.revenuePriceGraph + "\"><\/div>";
		pageTemplate += "	<div id=\"" + Templates.Ids.unsupportedStatePopup + "\"><\/div>";

		return pageTemplate;
	}

	public static ChartModalTemplate()
	{
		var chartTemplate = "";
		chartTemplate += "<div class=\"container-fluid\">";
			
		// Price Details Row
		chartTemplate += "	<div class=\"row\">";
		chartTemplate += "		<div class=\"chart-header\">";

		// Details Column
		chartTemplate += "			<div class=\"chart-dates-labels col-sm-6 col-xs-12\">";
		chartTemplate += "				<table>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th>Year:<\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupYearDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th>Month:<\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupMonthDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th>Type:<\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupTypeDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th>Practice:<\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupPracticeDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th>Sales Close:<\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupSalesCloseDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th>Exchange:<\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupExchangeDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr id=\"" + Templates.Ids.popupFactorDataDiv + "\">";
		chartTemplate += "						<th>Factor:<\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupFactorDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "				<\/table>";
		chartTemplate += "			<\/div>";

		// Projected Table Column
		chartTemplate += "			<div class=\"chart-projections col-sm-6 col-xs-12\">";
		chartTemplate += "				<table>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th>Projected<\/th>";
		chartTemplate += "						<th>Volatility<\/th>";
		chartTemplate += "						<th>Harvested<\/th> ";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupProjectedDiv + "\"><\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupVolatilityDiv + "\"><\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupHarvestedDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "					<tr>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupProjectedStatusDiv + "\"><\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupVolatilityStatusDiv + "\"><\/th>";
		chartTemplate += "						<th id=\"" + Templates.Ids.popupHarvestedStatusDiv + "\"><\/th>";
		chartTemplate += "					<\/tr>";
		chartTemplate += "				<\/table>";
		chartTemplate += "			<\/div>";

		chartTemplate += "		<\/div>";
		chartTemplate += "	<\/div>"; //End row

		// Spacer Row
		chartTemplate += "	<div class=\"row hidden-xs\">";
		chartTemplate += "		<div class=\"col-xs-12\">&nbsp;<\/div>";
		chartTemplate += "	<\/div>";

		// Toggle Chart
		chartTemplate += "	<div class=\"row hidden-lg visible-xs\">";
		chartTemplate += "		 <div class=\"col-xs-12\">&nbsp;<\/div>";
		chartTemplate += "		 <div class=\"col-xs-11\" id=\"" + Templates.Ids.popupChartToggleDiv + "\">";
		chartTemplate += "				 Chart&nbsp;  <div id=\"" + Templates.Ids.popupMobileChartSwitch + "\"><\/div>";
		chartTemplate += "		 <\/div>";
		chartTemplate += "	<\/div>";

		// Chart Row
		chartTemplate += "	<div id=\"" + Templates.Ids.popupChartRow + "\" class=\"row hidden-xs\">";
		chartTemplate += "		<div class=\"col-xs-12 chart-container\">";
		chartTemplate += "			<div id=\"" + Templates.Ids.popupRevenuePricesChart + "\"><\/div>";
		chartTemplate += "		<\/div>";
		chartTemplate += "	<\/div>";

		//Spacer Row
		chartTemplate += "	<div class=\"row\">";
		chartTemplate += "		<div class=\"col-xs-12\">&nbsp;<\/div>";
		chartTemplate += "	<\/div>";

		// Base/Harvest Price Row
		chartTemplate += "	<div class=\"row\">";
		chartTemplate += "		<div class=\"col-sm-6 col-xs-12 clickable-modal-grid nau-data-grid \">";
		chartTemplate += "			<div id=\"" + Templates.Ids.popupBasePriceHeaderDiv + "\" class=\"chart-data-header\">Base Price<\/div>";
		chartTemplate += "			<div id=\"" + Templates.Ids.popupGridBasePriceDiv + "\" class=\"nau-data-grid\"><\/div>";
		chartTemplate += "		<\/div>";
		chartTemplate += "		<div class=\"col-sm-6 col-xs-12 clickable-modal-grid nau-data-grid \">";
		chartTemplate += "			<div id=\"" + Templates.Ids.popupHarvestPriceHeaderDiv + "\" class=\"chart-data-header\">Harvest Price<\/div>";
		chartTemplate += "			<div id=\"" + Templates.Ids.popupGridHarvestPriceDiv + "\" class=\"nau-data-grid\"><\/div>";
		chartTemplate += "		<\/div>";
		chartTemplate += "	<\/div>\"";
		chartTemplate += "<\/div>\""; // End Container
		return chartTemplate;
	}

	public static UnsupportedStateModalTemplate()
	{
		var unsupportedState = "";
		unsupportedState += "<div class=\"alert alert-warning col-xs-8 col-xs-offset-2\">";
		unsupportedState += "	<div class=\"\">&nbsp;<\/div>";
		unsupportedState += "	<div id=\"" + Templates.Ids.unsupportedStateText + "\"><\/div>";
		unsupportedState += "	<div class=\"\">&nbsp;<\/div>";
		unsupportedState += "<\/div>";

		return unsupportedState;
	}
}